import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import { Login } from "../pages/user/Login";
import { PasswordReset1 } from "../pages/user/PasswordReset1";
import { PasswordReset2 } from "../pages/user/PasswordReset2";
import { PasswordReset3 } from "../pages/user/PasswordReset3";
import { PasswordReset4 } from "../pages/user/PasswordReset4";
import { EmailTemplatePublish } from "../publish/EmailTemplatePublish";
import { PrivateLayout } from "../pages/layout/PrivateLayout";
import OuterLayout from "../pages/layout/OuterLayout";
import { OneOneInquiryPublish } from "../publish/OneOneInquiryPublish";
import { FaqListPublish } from "../publish/FaqListPublish";
import { FaqDetailPublish } from "../publish/FaqDetailPublish";
import { FaqDetailPublish2 } from "../publish/FaqDetailPublish2";
import { OneOneInquiryDetailPublish } from "../publish/OneOneInquiryDetailPublish";
import { RmaSearchPublish } from "../publish/RmaSearchPublish";
import { RmaDetailPublish } from "../publish/RmaDetailPublish";
import { OrderListPublish } from "../publish/OrderListPublish";
import { ShipmentListPublish } from "../publish/ShipmentListPublish";
import { ShipmentDetailPublish } from "../publish/ShipmentDetailPublish";
import { DeadlineListPublish } from "../publish/DeadlineListPublish";
import { InventoryGeneratePublish } from "../publish/InventoryGeneratePublish";
import { InventoryDetailPublish } from "../publish/InventoryDetailPublish";
import { BarcodePrintingPublish } from "../publish/BarcodePrintingPublish";
import { SearchInventoryDetailPublish } from "../publish/SearchInventoryDetailPublish";
import { RoleDetailPublish } from "../publish/RoleDetailPublish";
import { ItemsPagePublish } from "../publish/ItemsPagePublish";
import { ProductsPagePublish } from "../publish/ProductsPagePublish";
import { ProductDetailsPublish } from "../publish/ProductDetailsPublish";
import { ProductDetailsPublish2 } from "../publish/ProductDetailsPublish2";
import { SalesPublish } from "../publish/SalesPublish";
import { ViewOrderDetailsPublish } from "../publish/ViewOrderDetailsPublish";
import { SearchExhangeRatePublish } from "../publish/SearchExhangeRatePublish";
import { OrderTaxInvoicePublish } from "../publish/OrderTaxInvoicePublish";
import { SearchTaxInvoicePublish } from "../publish/SearchTaxInvoicePublish";
import { SearchReceiveablesPublish } from "../publish/SearchReceiveablesPublish";
import { RegisterForDeliveryPublish } from "../publish/RegisterForDeliveryPublish";
import { ViewDetailsWearingPublish } from "../publish/ViewDetailsWearingPublish";
import { RegisterForShipmentPublish } from "../publish/RegisterForShipmentPublish";
import { ViewShipmentDetailsPublish } from "../publish/ViewShipmentDetailsPublish";
import { AdjustmentRegistrationPublish } from "../publish/AdjustmentRegistrationPublish";
import { ViewAdjustmentDetailPublish } from "../publish/ViewAdjustmentDetailPublish";
import { SearchInventoryAnalysisPublish } from "../publish/SearchInventoryAnalysisPublish";
import { AlertsPublish } from "../publish/AlertsPublish";
import { FormulaSettingPublish } from "../publish/FormulaSettingPublish";
import { ExternalOrderListPublish } from "../publish/ExternalOrderListPublish";
import { ExternalOrderDetailsPublish } from "../publish/ExternalOrderDetailsPublish";
import { ExternalOrderDeliveryPublish } from "../publish/ExternalOrderDeliveryPublish";
import { ExternalOrderDeliveryDetailsPublish } from "../publish/ExternalOrderDeliveryDetailsPublish";
import { OrderBondPublish } from "../publish/OrderBondPublish";
import { CustomerBusinessPartnerPublish } from "../publish/CustomerBusinessPartnerPublish";
import { CustomerBusinessPartnerDetailPublish } from "../publish/CustomerBusinessPartnerDetailPublish";
import { CustomerContactPublish } from "../publish/CustomerContactPublish";
import { CustomerContactDetailPublish } from "../publish/CustomerContactDetailPublish";
import { CustomerProjectPublish } from "../publish/CustomerProjectPublish";
import { CustomerProjectDetailPublish } from "../publish/CustomerProjectDetailPublish";
import { CustomerTierPublish } from "../publish/CustomerTierPublish";
import { ProductSearchPublish } from "../publish/ProductSearchPublish";
import Product from "../pages/product/Product";
import NotFound from "../pages/common/NotFound";
import Main from "../pages/main/Main";
import Orders from "../pages/order/Orders";
import Inventory from "../pages/inventory/Inventory";
import Customer from "../pages/customer/Customer";
import Support from "../pages/support/Support";
import Manage from "../pages/manage/Manage";
import Purchase from "../pages/purchase/Purchase";
import { SearchBusinessPartnersPublish } from "../publish/SearchBusinessPartnersPublish";
import { SearchSystemUsersPublish } from "../publish/SearchSystemUsersPublish";
import { ViewPTAModelsPublish } from "../publish/ViewPTAModelsPublish";
import { ViewShipmentDetailPublish } from "../publish/ViewShipmentDetailPublish";
import { SerialNoSearchPublish } from "../publish/SerialNoSearchPublish";
import { CartPagePublish } from "../publish/CartPagePublish";

const accessToken = localStorage.getItem("mdstech_accessToken");
export const RouterConfig = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                path: "not_found",
                element: <NotFound />
            },
            {
                path: "",
                children: [{
                    element: (
                        <>{accessToken ? <Navigate to="main/dashboard" replace /> : <Navigate to="login" replace />}</>
                    ),
                    index: true,
                },
                {
                    element: <OuterLayout />,
                    path: "login",
                    children: [
                        {
                            path: "",
                            element: <Login />,
                        },
                        {
                            path: "pass_reset1",
                            element: <PasswordReset1 />,
                        },
                        {
                            path: "pass_reset2",
                            element: <PasswordReset2 />,
                        },
                        {
                            path: "pass_reset3/:id",
                            element: <PasswordReset3 />,
                        },
                        {
                            path: "pass_reset4",
                            element: <PasswordReset4 />,
                        },
                        {
                            path: "email",
                            element: <EmailTemplatePublish />,
                        },
                    ],
                },
                ]
            },
            {
                path: "main",
                element: <PrivateLayout />,
                children: [
                    {
                        path: "*",
                        element: <Main />
                    }
                ]
            },
            {
                path: "order",
                element: <PrivateLayout />,
                children: [
                    {
                        path: "*",
                        element: <Orders />
                    }
                ]
            },
            {
                path: "purchase",
                element: <PrivateLayout />,
                children: [
                    {
                        path: "*",
                        element: <Purchase />
                    }
                ]
            },
            {
                path: "product",
                element: <PrivateLayout />,
                children: [
                    {
                        path: "*",
                        element: <Product />
                    }
                ]
            },
            {
                path: "inventory",
                element: <PrivateLayout />,
                children: [
                    {
                        path: "*",
                        element: <Inventory />
                    }
                ]
            },
            {
                path: "customer",
                element: <PrivateLayout />,
                children: [
                    {
                        path: "*",
                        element: <Customer />
                    }
                ]
            },
            {
                path: "support",
                element: <PrivateLayout />,
                children: [
                    {
                        path: "*",
                        element: <Support />
                    }
                ]
            },
            {
                path: "manage",
                element: <PrivateLayout />,
                children: [
                    {
                        path: "*",
                        element: <Manage />
                    }
                ]
            },
            {
                path: "publish",
                element: <PrivateLayout />,
                children: [
                    {
                        path: "oneone_inquiry",
                        element: <OneOneInquiryPublish />,
                    },
                    {
                        path: "oneone_inquiry_detail",
                        element: <OneOneInquiryDetailPublish />,
                    },
                    {
                        path: "faq_list",
                        element: <FaqListPublish />,
                    },
                    {
                        path: "faq_detail",
                        element: <FaqDetailPublish />,
                    },
                    {
                        path: "faq_detail2",
                        element: <FaqDetailPublish2 />,
                    },
                    {
                        path: "rma_search",
                        element: <RmaSearchPublish />,
                    },
                    {
                        path: "rma_detail",
                        element: <RmaDetailPublish />,
                    },
                    {
                        path: "orders",
                        element: <OrderListPublish />,
                    },
                    {
                        path: "shipments",
                        element: <ShipmentListPublish />,
                    },
                    {
                        path: "shipment_detail",
                        element: <ShipmentDetailPublish />,
                    },
                    {
                        path: "view_shipment_detail",
                        element: <ViewShipmentDetailPublish />,
                    },
                    {
                        path: "deadlines",
                        element: <DeadlineListPublish />,
                    },
                    {
                        path: "inventory_gen",
                        element: <InventoryGeneratePublish />,
                    },
                    {
                        path: "inventory_detail",
                        element: <InventoryDetailPublish />,
                    },
                    {
                        path: "barcode_print",
                        element: <BarcodePrintingPublish />,
                    },
                    {
                        path: "search_inventory",
                        element: <SearchInventoryDetailPublish />,
                    },
                    {
                        path: "role_detail",
                        element: <RoleDetailPublish />,
                    },
                    {
                        path: "items_list",
                        element: <ItemsPagePublish />,
                    },
                    {
                        path: "products",
                        element: <ProductsPagePublish />,
                    },
                    {
                        path: "product_detail",
                        element: <ProductDetailsPublish />,
                    },
                    {
                        path: "product_detail2",
                        element: <ProductDetailsPublish2 />,
                    },
                    {
                        path: "order_details",
                        element: <ViewOrderDetailsPublish />,
                    },
                    {
                        path: "sales",
                        element: <SalesPublish />,
                    },
                    {
                        path: "products",
                        element: <ProductsPagePublish />,
                    },
                    {
                        path: "exchange_rate",
                        element: <SearchExhangeRatePublish />,
                    },
                    {
                        path: "order_taxinvoice",
                        element: <OrderTaxInvoicePublish />,
                    },
                    {
                        path: "search_taxinvoice",
                        element: <SearchTaxInvoicePublish />,
                    },
                    {
                        path: "search_receivables",
                        element: <SearchReceiveablesPublish />,
                    },
                    {
                        path: "register_fordelivery",
                        element: <RegisterForDeliveryPublish />,
                    },
                    {
                        path: "viewdetails_wearing",
                        element: <ViewDetailsWearingPublish />,
                    },
                    {
                        path: "registerfor_shipment",
                        element: <RegisterForShipmentPublish />,
                    },
                    {
                        path: "view_shipmentdetails",
                        element: <ViewShipmentDetailsPublish />,
                    },
                    {
                        path: "adjustment_register",
                        element: <AdjustmentRegistrationPublish />,
                    },
                    {
                        path: "view_adjustment",
                        element: <ViewAdjustmentDetailPublish />,
                    },
                    {
                        path: "search_inventory_analysis",
                        element: <SearchInventoryAnalysisPublish />,
                    },
                    {
                        path: "alerts",
                        element: <AlertsPublish />,
                    },
                    {
                        path: "formula_setting",
                        element: <FormulaSettingPublish />,
                    },
                    {
                        path: "ext_orders",
                        element: <ExternalOrderListPublish />,
                    },
                    {
                        path: "ext_order_detail",
                        element: <ExternalOrderDetailsPublish />,
                    },
                    {
                        path: "ext_order_delivery",
                        element: <ExternalOrderDeliveryPublish />,
                    },
                    {
                        path: "ext_order_delivery_details",
                        element: <ExternalOrderDeliveryDetailsPublish />,
                    },
                    {
                        path: "order_bond",
                        element: <OrderBondPublish />,
                    },
                    {
                        path: "cust_business_partner",
                        element: <CustomerBusinessPartnerPublish />,
                    },
                    {
                        path: "cust_business_partner_detail",
                        element: <CustomerBusinessPartnerDetailPublish />,
                    },
                    {
                        path: "customer_contact",
                        element: <CustomerContactPublish />,
                    },
                    {
                        path: "customer_contact_details",
                        element: <CustomerContactDetailPublish />,
                    },
                    {
                        path: "customer_projects",
                        element: <CustomerProjectPublish />,
                    },
                    {
                        path: "customer_projects",
                        element: <CustomerProjectPublish />,
                    },
                    {
                        path: "customer_project_detail",
                        element: <CustomerProjectDetailPublish />,
                    },
                    {
                        path: "customer_tier",
                        element: <CustomerTierPublish />,
                    },
                    {
                        path: "product_search",
                        element: <ProductSearchPublish />,
                    },
                    {
                        path: "search_business_partners",
                        element: <SearchBusinessPartnersPublish />,
                    },
                    {
                        path: "search_system_users",
                        element: <SearchSystemUsersPublish />,
                    },
                    {
                        path: "view_pta_modals",
                        element: <ViewPTAModelsPublish />,
                    },
                    {
                        path: "serial_no",
                        element: <SerialNoSearchPublish />,
                    },
                    {
                        path: "cart",
                        element: <CartPagePublish />,
                    }
                ]
            },
            {
                path: "*",
                element: <Navigate to={"/not_found"} />
            },
        ]
    }
]);

export default RouterConfig;
